import { SVGProps } from 'react'
import { Watch } from 'react-loader-spinner'

const LoaderIcon = (props: SVGProps<SVGSVGElement>) => (
  <Watch
    visible={true}
    ariaLabel="discuss-loading"
    wrapperStyle={{}}
    wrapperClass="discuss-wrapper"
    color={'#F6426F'}
    radius={48}
    {...props}
    height={48}
    width={48}
  />
  // Previous loader icon
  // <svg
  //   width="126"
  //   height="126"
  //   viewBox="0 0 126 126"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <path
  //     d="M63 10.5V31.5"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M63 94.5V115.5"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M25.8825 25.8826L40.74 40.7401"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M85.26 85.26L100.118 100.118"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M10.5 63H31.5"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M94.5 63H115.5"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M25.8825 100.118L40.74 85.26"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M85.26 40.7401L100.118 25.8826"
  //     stroke="#007CF0"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  // </svg>
)

export default LoaderIcon
